import { PURPOSE_SOURCE_VALUES } from '@sravni/creditselection-customer-utils/lib/utils/customers';

import { PRODUCT_TYPES_VALUES } from 'constants/dictionaries';

import type { TSelectedProductType } from 'shared/types/TCustomerService';

import { isKnownProductTypeValue } from './knownSelectedProductTypes';
import type { TProductTypeTabId } from './productTypeTab.types';

type TMapSelectedProductTypeToTabIdParams = {
  selectedProductType?: TSelectedProductType | null;
  purpose?: string | null;
};

export const mapSelectedProductTypeToTabId = ({
  selectedProductType,
  purpose,
}: TMapSelectedProductTypeToTabIdParams): TProductTypeTabId => {
  const normalizedProductType = isKnownProductTypeValue(selectedProductType)
    ? selectedProductType
    : PRODUCT_TYPES_VALUES.CREDIT;

  if (normalizedProductType === PRODUCT_TYPES_VALUES.CREDIT_CARD) {
    return 'creditCard';
  }

  if (normalizedProductType === PRODUCT_TYPES_VALUES.MICRO_CREDIT) {
    return 'microCredit';
  }

  if (normalizedProductType === PRODUCT_TYPES_VALUES.CREDIT && purpose === PURPOSE_SOURCE_VALUES.REFINANCE_CREDIT) {
    return 'refinance';
  }

  return 'cash';
};
